import React from 'react';
import unlimitedSVG from '../../../../images/lp/unlimited-package.svg';

export function Unlimited() {
    return (
        <section className="pt-[64px] lg:pt-[80px] md:max-w-[1008px] md:mx-auto md:px-6">
            <div className="flex flex-col md:flex-row align-center text-center bg-[#DCEDF3] md:rounded-[16px] py-7 px-6 md:px-[40px]">
                <img src={unlimitedSVG} alt="Unlimited Package" width="220" height="220" className="mx-auto" />
                <span className="mcl-font-proxima text-[20px] md:text-[32px] font-bold pt-3 pt-md-0 flex items-center md:text-left md:pl-8">
                    With Milan Laser’s Unlimited Package™, you’re covered for life – no matter how many treatments you
                    need.
                </span>
            </div>
        </section>
    );
}

export default Unlimited;
